import { ActiveCartGiftWithPurchases, ActiveCartItem } from 'types/cart';

import { SelectedItemType } from '../types';

export const doesSelectedItemMatchInCartItem = (
  selected: SelectedItemType,
  inCart: ActiveCartItem,
  giftWithPurchase?: ActiveCartGiftWithPurchases
) => {
  if (inCart.__typename !== 'ProductCartItem') return false;
  const matchingPromo = giftWithPurchase!.id === inCart.bonusItemId;
  const matchingId = selected.id === inCart.product.masterId;
  const matchingSize = selected.size.id === inCart.product.size.value;
  const matchingColor = selected.color === inCart.product.colorValue;
  return matchingPromo && matchingId && matchingSize && matchingColor;
};
